/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectProgressCommand } from '../../models/create-project-progress-command';
import { CreateProjectProgressCommandResult } from '../../models/create-project-progress-command-result';

export interface ApiProjectProgressCreateProgressPost$Params {
      body?: CreateProjectProgressCommand
}

export function apiProjectProgressCreateProgressPost(http: HttpClient, rootUrl: string, params?: ApiProjectProgressCreateProgressPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectProgressCreateProgressPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectProgressCommandResult>;
    })
  );
}

apiProjectProgressCreateProgressPost.PATH = '/api/ProjectProgress/CreateProgress';
